export default __webpack_public_path__ + "static/franchiseProcessCN-540000aea24d6002644990077617b390.jpg";